import styled from 'styled-components'

import { NATIVE_BASE_COLORS } from '../../../themes'

const palette = key => props => props.palette[key]

const FOREGROUND = NATIVE_BASE_COLORS.TEXT[900]
const FOREGROUND_ALT = '#363636'
const BORDER = NATIVE_BASE_COLORS.TEXT[200]
const AVAILABLE_FILL = NATIVE_BASE_COLORS.TEXT[300]
const DESK_FILL_OPACITY = 0.5
const BUSY_FILL_OPACITY = 0.7
const DESK_STROKE = '#0A0A0A'
const SELECTED_STROKE = '#EF4444'
const MATCH_OVERLAY = '#000000'
const MATCH_OVERLAY_OPACITY = 0.3
const TOOLTIP_BG = '#000000'
const SHADOW_SM = '0 1px 2px rgba(0, 0, 0, 0.1)'
const SHADOW_MD = '0 2px 4px -2px rgba(0, 0, 0, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1)'
const SHADOW_LG = '0 4px 6px -4px rgba(0, 0, 0, 0.1), 0 10px 15px -3px rgba(0, 0, 0, 0.1)'

const Style = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 96vh;
  background-color: #FFFFFF;

  .desk-modal-heading {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
  }

  .desk-modal-title-row {
    display: flex;
    align-items: center;
    gap: 16px;
    min-height: 40px;
  }

  .desk-modal-title {
    flex: 1;
    min-width: 0;
    font-family: LibreBaskervilleBold;
    font-size: 32px;
    line-height: 32px;
    letter-spacing: -1px;
    color: ${FOREGROUND};
    word-break: break-word;
  }

  .is-searching .desk-modal-title {
    flex: 1 1 0;
    min-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: normal;
  }

  .desk-modal-icon-button {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-left: auto;
    padding: 0;
    border: none;
    border-radius: 50%;
    background-color: ${palette('tint')};
    cursor: pointer;
  }

  .desk-modal-icon-button img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  .desk-search {
    flex: 0 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 0 auto;
  }

  .desk-search .desk-modal-icon-button {
    margin-left: 0;
    box-shadow: ${SHADOW_MD};
  }

  .desk-search-input,
  .desk-search-type-toggle {
    box-sizing: border-box;
    height: 48px;
    padding: 12px 16px;
    border: 1.5px solid ${BORDER};
    border-radius: 8px;
    background-color: #FFFFFF;
    box-shadow: ${SHADOW_MD};
    font-family: NunitoSansRegular;
    font-size: 18px;
    line-height: 24px;
    color: ${FOREGROUND};
    outline: none;
  }

  .desk-search-input {
    flex: 0 1 300px;
    min-width: 0;
    width: 300px;
  }

  .desk-search-input::placeholder {
    color: ${NATIVE_BASE_COLORS.TEXT[500]};
  }

  .desk-search-input:focus {
    border-color: ${palette('main')};
  }

  .desk-search-type {
    position: relative;
    flex-shrink: 0;
  }

  .desk-search-type-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 180px;
    cursor: pointer;
  }

  .desk-search-type-toggle img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .desk-search-type-list {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 3;
    margin: 0;
    padding: 4px 0;
    list-style: none;
    border: 1px solid ${BORDER};
    border-radius: 8px;
    background-color: #FFFFFF;
    box-shadow: ${SHADOW_LG};
  }

  .desk-search-type-list li {
    padding: 8px 16px;
    font-family: NunitoSansRegular;
    font-size: 18px;
    line-height: 24px;
    color: ${FOREGROUND};
    cursor: pointer;
  }

  .desk-search-type-list li:hover,
  .desk-search-type-list li.active {
    background-color: ${palette('tint')};
  }

  .desk-modal-legend {
    display: flex;
    align-items: center;
    gap: 24px;
    min-height: 32px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: NunitoSansSemiBold;
    font-size: 16px;
    line-height: 24px;
    color: ${FOREGROUND_ALT};
  }

  .legend-item::before {
    content: '';
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border: 1px solid #F9F6F2;
    border-radius: 50%;
    box-shadow: ${SHADOW_SM};
  }

  .legend-item.available::before {
    background-color: ${AVAILABLE_FILL};
  }

  .legend-item.busy::before {
    background-color: ${palette('main')};
  }

  .legend-owner-icon {
    width: 16px;
    height: 16px;
    background-color: currentColor;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }

  .desk-modal-filters {
    display: flex;
    gap: 16px;
  }

  .filter-input {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    height: 48px;
    padding: 12px 16px;
    border: 1.5px solid ${BORDER};
    border-radius: 8px;
    background-color: #FFFFFF;
    font-family: NunitoSansRegular;
    font-size: 18px;
    line-height: 24px;
    color: ${FOREGROUND};
    cursor: pointer;
    outline: none;
  }

  .filter-input img {
    position: absolute;
    right: 16px;
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .filter-input:disabled {
    cursor: not-allowed;
    background-color: ${NATIVE_BASE_COLORS.TEXT[100]};
  }

  .desk-modal-body {
    display: flex;
    flex: 1;
    min-height: 0;
    padding: 24px;
  }

  .desk-modal-plan {
    position: relative;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .plan-viewport {
    flex: 1;
    min-height: 0;
    max-height: 56vh;
    overflow: auto;
  }

  .has-card .plan-viewport {
    padding-bottom: 150px;
  }

  .plan-canvas {
    position: relative;
    transition: opacity 0.2s;
  }

  .plan-canvas.is-loading {
    opacity: 0.5;
  }

  .plan-image {
    display: block;
    width: 100%;
    object-fit: contain;
  }

  .desk-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .desk {
    cursor: pointer;
  }

  .desk polygon {
    stroke: ${DESK_STROKE};
    stroke-width: 3px;
    fill-opacity: ${DESK_FILL_OPACITY};
    transition: fill 0.2s;
  }

  .desk.available polygon {
    fill: ${AVAILABLE_FILL};
  }

  .desk.busy polygon {
    fill: ${palette('main')};
    fill-opacity: ${BUSY_FILL_OPACITY};
  }

  .desk:hover polygon {
    filter: brightness(0.95);
  }

  .desk.selected polygon {
    stroke: ${SELECTED_STROKE};
  }

  .desk polygon.desk-match-overlay {
    fill: ${MATCH_OVERLAY};
    fill-opacity: ${MATCH_OVERLAY_OPACITY};
    stroke: none;
    pointer-events: none;
  }

  .desk-tooltip {
    position: absolute;
    z-index: 2;
    box-sizing: border-box;
    transform: translate(-50%, calc(-100% - 11px));
    min-width: 80px;
    max-width: 240px;
    padding: 6px 8px;
    border-radius: 6px;
    background-color: ${TOOLTIP_BG};
    font-family: NunitoSansRegular;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
    pointer-events: none;
  }

  .desk-tooltip span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .desk-tooltip::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -4px;
    width: 8px;
    height: 8px;
    border-radius: 0 0 2px 0;
    background-color: ${TOOLTIP_BG};
    transform: translateX(-50%) rotate(45deg);
  }

  .desk-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border: 1px solid #FFFFFF;
    border-radius: 50%;
    background-color: ${palette('deskBg')};
    box-shadow: ${SHADOW_SM};
  }

  .desk-icon {
    background-color: ${palette('deskFg')};
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }

  .plan-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 8px 16px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.9);
    font-family: NunitoSansSemiBold;
    font-size: 14px;
    line-height: 20px;
    color: ${FOREGROUND_ALT};
    pointer-events: none;
  }

  .desk-card {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    border-radius: 8px;
    box-shadow: ${SHADOW_LG};
  }

  .desk-card-divider {
    flex-shrink: 0;
    width: 12px;
    border-radius: 8px 0 0 8px;
    background-color: ${palette('deskBg')};
  }

  .desk-card-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    border: 1px solid ${palette('deskBg')};
    border-left: none;
    border-radius: 0 8px 8px 0;
    background-color: #FFFFFF;
  }

  .desk-card-name {
    font-family: NunitoSansSemiBold;
    font-size: 16px;
    line-height: 24px;
    color: ${FOREGROUND_ALT};
    word-break: break-word;
  }

  .desk-card-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 4px;
  }

  .meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: NunitoSansRegular;
    font-size: 14px;
    line-height: 20px;
    color: ${FOREGROUND};
  }

  .meta-item img {
    width: 12px;
    height: 12px;
    object-fit: contain;
  }

  .desk-card-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
  }

  .chip {
    padding: 1px 4px;
    border-radius: 2px;
    background-color: ${palette('tint')};
    font-family: NunitoSansRegular;
    font-size: 14px;
    line-height: 20px;
    color: ${FOREGROUND};
  }

  .desk-modal-footer {
    display: flex;
    gap: 16px;
    padding: 24px;
    border-top: 1px solid ${BORDER};
    background-color: #FFFFFF;
  }

  .btn-cancel,
  .btn-confirm {
    flex: 1;
    height: 48px;
    padding: 12px;
    border-radius: 8px;
    font-family: NunitoSansSemiBold;
    font-size: 16px;
    line-height: 24px;
    color: ${FOREGROUND};
    cursor: pointer;
  }

  .btn-cancel {
    border: 2px solid ${BORDER};
    background-color: #FFFFFF;
  }

  .btn-confirm {
    border: none;
    background-color: ${palette('main')};
    color: ${palette('onMain')};
  }

  .btn-confirm:disabled {
    background-color: ${BORDER};
    color: ${NATIVE_BASE_COLORS.TEXT[400]};
    cursor: not-allowed;
  }
`

export default Style
